import cx from 'classnames'
import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {Button} from 'components/system'
import {Warning} from 'components/system/Warning'
import {useMemo} from 'react'
import {StepDataProvider} from '../../../../providers/StepDataProvider/StepDataProvider'
import {Guest} from './Guest'

export const MaximizedGuests = () => {
  const units = VentrataDataProvider.useUnits('optional')
  const dataManager = StepDataProvider.useGuestsDataManager()
  const optionalOptionId = InputProvider.useOptionId('optional')
  const optionalOption = VentrataDataProvider.useOption(optionalOptionId, 'optional')
  const totalUnitsCounter = StepDataProvider.guests.useTotalUnitsCounter()

  const maxGuestsForOption = useMemo(() => {
    return optionalOption?.restrictions?.maxUnits
  }, [optionalOption])

  const isMaxNumberOfGuestsForOptionExeeded = useMemo(() => {
    return Boolean(maxGuestsForOption && totalUnitsCounter === maxGuestsForOption)
  }, [maxGuestsForOption, totalUnitsCounter])

  if (units.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-6">
      {units.map((unit) => {
        return (
          <Guest
            key={unit.id}
            unitId={unit.id}
            isMaxNumberOfGuestsForOptionExeeded={isMaxNumberOfGuestsForOptionExeeded}
          />
        )
      })}

      {isMaxNumberOfGuestsForOptionExeeded && (
        <Warning>You've added the maximum number of guests for this tour ({maxGuestsForOption})</Warning>
      )}

      <Button.Primary.Orange
        onClick={() => dataManager.save()}
        autoExpanded
        className={cx('ml-auto', dataManager.isValid() ? '!bg-theme' : '!bg-inactive-gray')}
      >
        Next
      </Button.Primary.Orange>
    </div>
  )
}
